import { every, size } from 'lodash';
import { isCNPJ, isCPF } from 'validation-br';
import { z } from 'zod';

const contactSchema = z.object({
  subjectCategory: z
    .string({
      required_error: 'Por favor, selecione a categoria de assunto'
    })
    .min(1, 'Por favor, selecione a categoria de assunto'),
  subject: z
    .string({
      required_error: 'Por favor, selecione o assunto'
    })
    .min(1, 'Por favor, selecione o assunto'),
  name: z.string().trim().min(1, 'Por favor, digite seu nome'),
  socialName: z.string().trim().optional(),
  linkWithCompany: z
    .string({
      required_error: 'Por favor, selecione o vínculo com a empresa'
    })
    .min(1, 'Por favor, selecione o vínculo com a empresa'),
  email: z
    .string()
    .min(1, 'Por favor, digite seu e-mail')
    .email('Por favor, digite um e-mail válido'),
  identity: z
    .string()
    .refine((identity) => {
      const identitySize = size(identity?.replace(/\D/g, ''));
      return identitySize === 11 || identitySize === 14;
    }, 'Por favor, insira um CPF/CNPJ válido')
    .refine((identity) => {
      const cleanedIdentity = identity?.replace(/\D/g, '');

      if (cleanedIdentity && size(cleanedIdentity) === 11) {
        return isCPF(cleanedIdentity);
      }
      return true;
    }, 'Por favor, insira um CPF válido')
    .refine((identity) => {
      const cleanedIdentity = identity?.replace(/\D/g, '');

      if (cleanedIdentity && size(cleanedIdentity) === 14) {
        return isCNPJ(cleanedIdentity);
      }
      return true;
    }, 'Por favor, insira um CNPJ válido'),
  phone: z
    .string()
    .optional()
    .refine((phone) => {
      if (!phone) return true;
      return size(phone?.replace(/\D/g, '')) >= 10;
    }, 'Por favor, digite um telefone válido'),
  message: z.string().trim().min(1, 'Por favor, digite sua mensagem'),
  authorization: z
    .string()
    .refine((value) => value === 'true', 'Por favor, aceite os termos de uso'),
  file:
    typeof window === 'undefined'
      ? z.any().optional()
      : z
          .instanceof(FileList)
          .optional()
          .refine((files) => {
            if (size(files) === 0) return true;
            return every(files, (file) => file.size < 20 * 1024 * 1024);
          }, 'Por favor, adicione arquivos menores que 20MB')
});

type ContactForm = z.infer<typeof contactSchema>;

const DEFAULT_VALUES: ContactForm = {
  subjectCategory: '',
  subject: '',
  name: '',
  linkWithCompany: '',
  email: '',
  identity: '',
  phone: '',
  message: '',
  authorization: 'false' as any,
  file: undefined
};

export { DEFAULT_VALUES, contactSchema, type ContactForm };
